import React from 'react';
import { AgentInfo, AgentType, AgentCategory } from '../types';
import { 
  HomeIcon, 
  MagnifyingGlassIcon, 
  ArrowsRightLeftIcon as HeroArrowsRightLeftIcon, 
  AcademicCapIcon, 
  PencilSquareIcon, 
  UserGroupIcon, 
  InformationCircleIcon, 
  MegaphoneIcon,
  SparklesIcon,
  TagIcon,
  PresentationChartBarIcon,
  QueueListIcon,
  ShareIcon,
  ArrowPathIcon,
  GlobeAltIcon,
  ClockIcon,
  BarsArrowDownIcon,
  SquaresPlusIcon,
  IdentificationIcon,
  LinkIcon,
  DocumentTextIcon,
  BookOpenIcon,
  BeakerIcon,
} from '@heroicons/react/24/outline';

const BASE_URL = "884983460917.us-west1.run.app";
export const GEMINI_TEXT_MODEL = 'gemini-2.5-flash';

export const AGENTS: AgentInfo[] = [
  // Welcome Agent (No Category)
  { 
    id: AgentType.WELCOME, 
    name: 'MENU', 
    description: 'Página inicial de boas-vindas.', 
    icon: <HomeIcon className="w-6 h-6" /> 
  },
  { 
    id: AgentType.DEVOCIONAL_PESSOAL, 
    name: 'Devocional Pessoal', 
    description: 'Cria um guia de devocional pessoal baseado em uma passagem bíblica.', 
    icon: <BookOpenIcon className="w-6 h-6" />,
    url: `https://devocional-pessoal-${BASE_URL}`
  },
  
  // == Investigating Texts ==
  { 
    id: AgentType.WORD_ANALYZER, 
    name: 'Analisar Palavras', 
    description: 'Analisa palavras e o significado em passagens bíblicas, oferecendo sumarização e insights.', 
    icon: <BeakerIcon className="w-6 h-6" />,
    category: AgentCategory.INVESTIGATING_TEXTS,
    url: `https://analisar-palavras-${BASE_URL}`
  },
  { 
    id: AgentType.CHARACTERS, 
    name: 'Caracterizar Personagens', 
    description: 'Cria perfis detalhados de personagens.', 
    icon: <UserGroupIcon className="w-6 h-6" />,
    category: AgentCategory.INVESTIGATING_TEXTS,
    url: `https://caracterizar-personagens-${BASE_URL}`
  },
  {
    id: AgentType.TRANSLATION_COMPARATOR,
    name: 'Comparar Traduções',
    description: 'Compara diferentes traduções de passagens bíblicas lado a lado.',
    icon: <HeroArrowsRightLeftIcon className="w-6 h-6" />,
    category: AgentCategory.INVESTIGATING_TEXTS,
    url: 'https://comparar-traducoes-884983460917.us-west1.run.app/'
  },
  { 
    id: AgentType.BIBLICAL_UNIT_IDENTIFIER, 
    name: 'Delimitar Unidades', 
    description: 'Identifica e analisa unidades textuais em passagens bíblicas.', 
    icon: <QueueListIcon className="w-6 h-6" />,
    category: AgentCategory.INVESTIGATING_TEXTS,
    url: `https://delimitar-unidades-${BASE_URL}`
  },
  { 
    id: AgentType.LITERARY_FORM, 
    name: 'Identificar Forma Literária', 
    description: 'Identifica a forma literária de textos bíblicos.', 
    icon: <PencilSquareIcon className="w-6 h-6" />,
    category: AgentCategory.INVESTIGATING_TEXTS,
    url: `https://identificar-forma-literaria-${BASE_URL}`
  },
  {
    id: AgentType.CONTEXT_RESEARCHER,
    name: 'Pesquisar Contexto',
    description: 'Fornece informações contextuais históricas, culturais e literárias sobre passagens bíblicas.',
    icon: <InformationCircleIcon className="w-6 h-6" />,
    category: AgentCategory.INVESTIGATING_TEXTS,
    url: `https://pesquisar-contexto-${BASE_URL}`
  },

  // == Mapping Themes ==
  {
    id: AgentType.GENERATE_BOOK_THEOLOGY,
    name: 'Apresentar Teologia Livros',
    description: 'Gera um panorama da teologia de um livro ou uma seção da Bíblia.',
    icon: <DocumentTextIcon className="w-6 h-6" />,
    category: AgentCategory.MAPPING_THEMES,
    url: `https://apresentar-teologia-livros-${BASE_URL}`
  },
  {
    id: AgentType.BIOGRAPH_CHARACTERS,
    name: 'Biografar Personagens',
    description: 'Cria biografias teológicas de personagens bíblicos.',
    icon: <IdentificationIcon className="w-6 h-6" />,
    category: AgentCategory.MAPPING_THEMES,
    url: `https://biografar-personagens-${BASE_URL}`
  },
  {
    id: AgentType.DESCRIBE_THEOLOGIES,
    name: 'Descrever Teologias',
    description: 'Descreve as principais teologias presentes em um livro ou passagem.',
    icon: <BarsArrowDownIcon className="w-6 h-6" />,
    category: AgentCategory.MAPPING_THEMES,
    url: `https://descrever-teologias-${BASE_URL}`
  },
  {
    id: AgentType.EXPLORE_THEMES,
    name: 'Explorar Temas',
    description: 'Explora e desenvolve temas teológicos chave de um texto.',
    icon: <SquaresPlusIcon className="w-6 h-6" />,
    category: AgentCategory.MAPPING_THEMES,
    url: `https://explorar-temas-${BASE_URL}`
  },
  {
    id: AgentType.RELATE_TEXTS,
    name: 'Relacionar Textos',
    description: 'Encontra e analisa conexões teológicas entre diferentes textos bíblicos.',
    icon: <LinkIcon className="w-6 h-6" />,
    category: AgentCategory.MAPPING_THEMES,
    url: `https://relacionar-textos-${BASE_URL}`
  },
  
  // == Exploring Meanings ==
  {
    id: AgentType.TEXT_UPDATER,
    name: 'Atualizar Textos',
    description: 'Atualiza textos bíblicos para uma linguagem contemporânea e acessível.',
    icon: <ArrowPathIcon className="w-6 h-6" />,
    category: AgentCategory.EXPLORING_MEANINGS,
    url: `https://atualizar-texto-${BASE_URL}`
  },
  {
    id: AgentType.WORLDVIEW_ANALYZER,
    name: 'Examinar Cosmovisão',
    description: 'Analisa a cosmovisão presente em uma passagem ou texto.',
    icon: <GlobeAltIcon className="w-6 h-6" />,
    category: AgentCategory.EXPLORING_MEANINGS,
    url: `https://examinar-cosmovisao-${BASE_URL}`
  },
  {
    id: AgentType.INTERPRETATION_HISTORIAN,
    name: 'Historiar Interpretação',
    description: 'Pesquisa e resume o histórico de interpretação de uma passagem bíblica ao longo do tempo.',
    icon: <ClockIcon className="w-6 h-6" />,
    category: AgentCategory.EXPLORING_MEANINGS,
    url: `https://historiar-interpretacao-${BASE_URL}`
  },
  
  // == Preparing Messages ==
  {
    id: AgentType.SERMON_BUILDER,
    name: 'Construir Sermão', 
    description: 'Ajuda a construir e desenvolver sermões e pregações.',
    icon: <MegaphoneIcon className="w-6 h-6" />,
    category: AgentCategory.PREPARING_MESSAGES,
    url: `https://construir-sermao-${BASE_URL}`
  },
  {
    id: AgentType.BIBLE_STUDY_CREATOR,
    name: 'Criar Estudo Bíblico', 
    description: 'Auxilia na criação de estudos bíblicos, desde esboços a materiais completos.',
    icon: <AcademicCapIcon className="w-6 h-6" />,
    category: AgentCategory.PREPARING_MESSAGES,
    url: `https://criar-estudo-biblico-${BASE_URL}`
  },
  {
    id: AgentType.TARGET_AUDIENCE_DEFINER,
    name: 'Definir Público-alvo', 
    description: 'Ajuda a identificar e definir o público-alvo para comunicação eficaz.',
    icon: <TagIcon className="w-6 h-6" />,
    category: AgentCategory.PREPARING_MESSAGES,
    url: `https://definir-publico-alvo-${BASE_URL}`
  },
  {
    id: AgentType.ILLUSTRATION_GENERATOR,
    name: 'Gerar Ilustrações',
    description: 'Gera ilustrações e analogias para enriquecer sermões e estudos.',
    icon: <SparklesIcon className="w-6 h-6" />,
    category: AgentCategory.PREPARING_MESSAGES,
    url: `https://gerar-ilustracoes-${BASE_URL}`
  },
  {
    id: AgentType.LESSON_PREPARER,
    name: 'Preparar Aula',
    description: 'Auxilia na preparação de planos de aula e materiais didáticos bíblicos.',
    icon: <PresentationChartBarIcon className="w-6 h-6" />,
    category: AgentCategory.PREPARING_MESSAGES,
    url: `https://preparar-aula-${BASE_URL}`
  },
  {
    id: AgentType.POST_CREATOR,
    name: 'Sugerir Posts',
    description: 'Desenvolve conteúdo para redes sociais baseado em passagens e temas bíblicos.',
    icon: <ShareIcon className="w-6 h-6" />,
    category: AgentCategory.PREPARING_MESSAGES,
    url: `https://sugerir-posts-${BASE_URL}`
  },
];
